module.exports = __webpack_public_path__ + "static/media/snippety.7e489500.png";